
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EnhancedLandingPage } from "@/components/home/EnhancedLandingPage";
import { supabase } from '@/integrations/supabase/client';
import { Loader2, AlertCircle } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

const Index = () => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [debugInfo, setDebugInfo] = useState<any>({});

  useEffect(() => {
    const checkSession = async () => {
      setIsChecking(true);
      try {
        console.log('Index: Checking session...');
        const { data, error } = await supabase.auth.getSession();
        
        setDebugInfo({
          hasSession: !!data.session,
          sessionUser: data.session?.user ? {
            id: data.session.user.id,
            email: data.session.user.email,
            role: data.session.user.user_metadata?.role || 'none'
          } : null,
          error: error ? error.message : null
        });
        
        if (error) {
          console.error('Session check error:', error);
          setError(error.message);
          setIsChecking(false);
          return;
        }
        
        if (data.session) {
          console.log('User is authenticated, redirecting to dashboard');
          navigate('/dashboard');
        } else {
          console.log('No active session found, staying on landing page');
          setIsChecking(false);
        }
      } catch (err: any) {
        console.error('Error checking session:', err);
        setError(err.message || 'Unknown error occurred');
        setIsChecking(false);
      }
    };

    checkSession();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4">
        <Alert variant="destructive" className="max-w-md mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error checking session</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
        
        <div className="bg-gray-50 p-4 rounded border max-w-md w-full">
          <h3 className="text-sm font-medium mb-2">Debug Information:</h3>
          <pre className="text-xs overflow-auto bg-gray-100 p-2 rounded">
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
          <div className="flex space-x-2 mt-4">
            <Button 
              onClick={() => navigate('/login')}
              variant="outline"
            >
              Go to Login
            </Button>
            <Button 
              onClick={() => window.location.reload()}
            >
              Retry
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (isChecking) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
        <span className="text-lg">Checking authentication status...</span>
        <span className="text-sm text-muted-foreground mt-2">Please wait</span>
      </div>
    );
  }

  return <EnhancedLandingPage />;
};

export default Index;
